module.exports = __webpack_public_path__ + "img/bg3.f96b9ec8.jpg";